import styled from "styled-components";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ReadMoreIcon from "@mui/icons-material/ReadMore";
import { ChannelResult } from "common/channel/dto/ChannelResult";
import { NavLink } from "react-router-dom";
import { useChannelDelete } from "hooks/matsend/channel/useChannelDelete";
import { QUERY_KEYS } from "constant/react_query";
import { channelLinkSingle } from "common/channel/channel_link_common";
import useConfirm from "common/modal/ConfirmDialog";

type ChannelSingleNavProps = {
  channel: ChannelResult;
  hideEditNav?: boolean;
  hideReadNav?: boolean;
};

const ChannelSingleNav = ({
  channel,
  hideEditNav,
  hideReadNav,
}: ChannelSingleNavProps) => {
  const { channelDeleteMutate } = useChannelDelete({
    invalidateKeys: [QUERY_KEYS.MATSEND_CHANNEL_SEARCH],
  });

  const actionConfirm = useConfirm();

  const deleteHandle = async () => {
    const check = await actionConfirm({
      title: "Channel",
      message: "Are you sure you want to delete channel",
    });
    if (check) {
      channelDeleteMutate(channel.id);
    }
  };

  return (
    <DivNav>
      <DeleteIcon onClick={deleteHandle} />
      {!hideEditNav && (
        <NavLink to={channelLinkSingle(channel.id, true)}>
          <EditIcon />
        </NavLink>
      )}
      {!hideReadNav && (
        <NavLink to={channelLinkSingle(channel.id)}>
          <ReadMoreIcon />
        </NavLink>
      )}
    </DivNav>
  );
};

const DivNav = styled.div`
  margin-top: 0.75rem;
  svg {
    margin-left: 1rem;
    cursor: pointer;
  }
  svg:hover {
    opacity: 0.8;
  }
  &&& > svg:first-of-type {
    margin-left: 0;
  }
`;

export default ChannelSingleNav;
